<ng-container *ngIf="image">
  <img src="{{image.url}}" />
  <div class="image-text">{{text}}</div>
  <mat-divider *ngIf="!hideDivider"></mat-divider>
</ng-container>
